// removed by extract-text-webpack-plugin
module.exports = {"component":"_1GF5aF1eG4sw0ytnVZcJLE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankYouPage/BoletoWidgetPage/boletoWidget.css
// module id = 1274
// module chunks = 2